import React, { useEffect, useRef, useState } from 'react';

import { nwkData, clone_data, phylo_info_data, bulk_data, bulk_tile_data, early_pointmts_data} from '../data/WebtoolData'

import GiHuman from "../chart/GiHuman"
import Screen2Phylogram from "../card/chart/Screen2Phylogram"

import Screen2Grid from "../card/grid/Screen2Grid"
import Screen3Grid from "../card/grid/Screen3Grid"
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface MatchParams {
  deadbody: string;
}

function Screen2({ history, match }: RouteComponentProps<MatchParams>) {

  const defaultDeadbodyValue:string = match.params.deadbody;
  const defaultScreenValue:string   = 'Screen2';
  
  const card1:any = useRef();
  const card2:any = useRef();

  let [isFirst, setFirst] = useState<boolean>(true);
  let [deadbody, setDeadbody] = useState<string>(defaultDeadbodyValue);

  const [cloneData, cloneDetailData] = clone_data();
  const phyloAllInfoData:any = phylo_info_data();

  let [cloneLocationData, setCloneLocationData] = useState(cloneData[deadbody]);
  const deadBasicData:any = nwkData();
  let [newickData, setNewickData] = useState(deadBasicData[deadbody].nwkData);
  let [sex, setSex] = useState(deadBasicData[deadbody].sex);

  const bulk_all_data = bulk_data();
  const bulkAllTileData = bulk_tile_data();
  const early_pointmts_all_data = early_pointmts_data();

  let [bulkData, setBulkData]                   = useState(bulk_all_data[deadbody]);
  let [bulkTileData, setBulkTileData]           = useState(bulkAllTileData[deadbody]);
  let [phyloInfoData, setPhyloInfoData]         = useState(phyloAllInfoData[deadbody]);
  let [earlyPointmtsData, setEarlyPointmtsData] = useState(early_pointmts_all_data[deadbody]);

  let [initScreen2Phylogram, setScreen2Phylogram] = useState<any>({
    phylogeneticBulkName: "",
    callback_after_click_reck: clickReckOnPhylogram
  });

  let [initScreen3Grid, setInitScreen3Grid] = useState<any>({
  });


  function clickReckOnPhylogram(bulkId:string, data:any) {
    
    if(initScreen3Grid.click_on_path) {
      initScreen3Grid.click_on_path(bulkId, data.name);
    }
  }

  let [initScreen2Grid, setInitScreen2Grid] = useState<any>({
    click_on_row: function(data:any, isSelected: boolean, bulkTileData?:any, rowDatas?:any[]){
      let selectedOrganName:string = data.tissue_group;
      let x: number = 0;
      let y: number = 0;
      let strokeDasharray: any;

      if(bulkTileData){
          x = bulkTileData[data.bulk_id].x;
          y = bulkTileData[data.bulk_id].y;
          strokeDasharray = bulkTileData[data.bulk_id].strokeDasharray
      }

      if(initGiHumanData.writeSeletedTitle){
          initGiHumanData.resetSeletedTitle();
          initGiHumanData.writeSeletedTitle(selectedOrganName, isSelected, data.bulk_name, data.color, x, y, strokeDasharray, true);
      }

      // let isOtherSeleted:boolean = false;
      // if(rowDatas){
      //   rowDatas.forEach(function(rowdata:any) {
      //     if(rowdata !== data && rowdata.tissue_group === data.tissue_group && rowdata.selected ){
      //         isOtherSeleted = true;
      //         return true;
      //     }
      //   })
      // }
      
      if(initGiHumanData.activeOrgan){
        initGiHumanData.resetOrgan();
        initGiHumanData.activeOrgan(selectedOrganName, isSelected);
      }

      if(initScreen2Phylogram.onDrawVafRect){
        initScreen2Phylogram.onDrawVafRect(data.bulk_name, data.bulk_id)
      }

      if(initScreen3Grid.click_on_path){
        initScreen3Grid.click_on_path();
      }

  }
  });


  function changeScreenbody(screenValue: string){
    history.push({
      pathname:`/${screenValue}/${deadbody}`,
      state: {deadbody: deadbody}
    })
  }

  function changeDeadbody(deadbodyValue: string){
    setDeadbody(deadbodyValue);
  }

  let [initGiHumanData, setInitGiHumanData]= useState<any>({ 
    width: 540,
    height: 580,
    // viewbox: {width: 400, height: 490},
    organ: true,
    sex: sex,
  });



  useEffect(() => {
    if(card1.current && card2.current){
      initGiHumanData.width      = card2.current.offsetWidth;
      initScreen2Phylogram.width = card1.current.offsetWidth + card2.current.offsetWidth + 20;
    }

    if(isFirst === false){
      initGiHumanData.sex = deadBasicData[deadbody].sex;

      setBulkData(bulk_all_data[deadbody]);
      setNewickData(deadBasicData[deadbody].nwkData);
      setCloneLocationData(cloneData[deadbody]);
      setSex(deadBasicData[deadbody].sex);
      setBulkTileData(bulkAllTileData[deadbody])
      setPhyloInfoData(phyloAllInfoData[deadbody]);
      setEarlyPointmtsData(early_pointmts_all_data[deadbody]);

      if(initScreen3Grid.click_on_path){
        initScreen3Grid.click_on_path();
      }
    }

    setFirst(false);
  }, [deadbody]);

  return (
    <div className="wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label htmlFor="ScreenSelect"> Screen</label>
              <select className="form-control" id="DeadbodySelect" onChange={(e) => changeScreenbody(e.currentTarget.value)} defaultValue={defaultScreenValue}>
                  <option value="Screen1">Start from phylogenetic tree</option>
                  <option value="Screen2">Start from bulk tissue</option>
              </select>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label htmlFor="DeadbodySelect"> Donor ID</label>
              <select className="form-control" id="DeadbodySelect" onChange={(e) => changeDeadbody(e.currentTarget.value)} defaultValue={defaultDeadbodyValue}>
                <option value="DB2">DB2</option>  
                <option value="DB3">DB3</option>  
                <option value="DB5">DB5</option>  
                <option value="DB6">DB6</option>  
                <option value="DB8">DB8</option>  
                <option value="DB9">DB9</option>  
                <option value="DB10">DB10</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4">
            <div className="short-div">
              <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">List of bulk tissues</h3>
                  </div>
                  <div className="card-body">
                    <div ref={card1}>
                    <Screen2Grid bulkTileData={bulkTileData} bulkData={bulkData} initialization={initScreen2Grid}/>
                    </div>
                    <p className="card-text">
                    When you click bulk tissues, you can see the location of those tissues in the below panel. When you click a bulk tissue, you can see the variant-allele frequency of early mutations in the tissue in the right panel.
                    </p>
                  </div>
              </div>
            </div>
            <div className="short-div">
              <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Location of bulk tissues</h3>
                  </div>
                  <div className="card-body">
                    <div ref={card2}>
                    <GiHuman initialization={initGiHumanData}/>
                    </div>
                  </div>
              </div>
            </div>
          </div>

          
          <div className="col-md-8">
            <div className="short-div">
            {(isFirst === false &&
              <Screen2Phylogram newickData={newickData} cloneLocationData={cloneLocationData} phyloInfoData={phyloInfoData} initialization={initScreen2Phylogram} />
            )}
            </div>
            <div className="short-div">
              <Screen3Grid gridData={earlyPointmtsData} bulkData={bulkData} initialization={initScreen3Grid}/>
            </div>
          </div>
          
        </div>
        {/* <div className="row">
          <div className="col-md-4">

          </div>
        </div> */}
      </div>
      </section>
    </div>
  );
  
}

export default withRouter(Screen2);